var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ChartNormal',{attrs:{"size":"12","offset":"0","title":"Under Warranty","chart":"column","chartType":"war","isCity":false,"withDate":true,"withFinancial":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }